import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { NestedRouteErrorComponent } from "@/components/organisms/ErrorBoundary/NestedRouteErrorComponent";
import { plantDetailRoute } from "@/pages/PlantDetail/route";

export const plantConfigurationVersionRoute = createRoute({
  path: "configurations/$version",
  getParentRoute: () => plantDetailRoute,
  component: lazyRouteComponent(async () => {
    const m =
      await import("./ConfigurationVersionPage/PlantConfigurationVersion");
    return { default: m.PlantConfigurationVersion };
  }),
  errorComponent: NestedRouteErrorComponent,
});
